import Modal from "../components/modal";

interface ModalProps<T> {
  title: string;
  isOpen: boolean;
  closeModal: () => void;
  handleCloseModal: () => void;
  children: React.ReactNode;
}

const ModalAddEdit = <T,>(props: ModalProps<T>) => {
  const { isOpen, closeModal, handleCloseModal, children } = props;

  return <Modal
    isOpen={isOpen}
    onRequestClose={closeModal}
    className="modal-small"
    shouldCloseOnOverlayClick={false}
  >
    <div className="uk-modal-header">
      <label className="uk-modal-title uk-text-large">{props.title}</label>
    </div>
    <button
      className="uk-modal-close-default"
      uk-close="true"
      type="button"
      onClick={handleCloseModal}
    />
      {children}
  </Modal>
}

export default ModalAddEdit;